module.exports = __webpack_public_path__ + "img/clock.6c1dd671.svg";